import Stepper from "components/Stepper";

const OnboardingPage = () => {
  return <Stepper />;
};

export default OnboardingPage;
